<template>
  <footer>
    <div class="container text-muted">
      <div class="pt-4 pb-4">
        <ul>
          <li><router-link to="/privacy">Privacy Policy</router-link></li>
          <li><router-link to="/contact">Contact Us</router-link></li>
        </ul>
        <p class="mb-0">
          Copyright © 2020 CodeHit. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss">
</style>
